module.exports = __webpack_public_path__ + "img/icon-1.324b443b.png";